<template>
	<div class="body">
		<header class="header-section">
			<h1 class="main-title">本月书单</h1>
      		<h1 class="main-title">📖 阅读，开启更多可能</h1>
			<div class="subtitle-wrapper">
				<span class="subtitle-badge">阅读</span>
				<span class="subtitle-badge">思考</span>
				<span class="subtitle-badge">成长</span>
			</div>
		</header>

		<section class="quote-card">
			<p class="p-highlight">精选优质好书，</p>
			<p class="p-content">在阅读中拓展视野、启发思考。</p>
			<div class="p-content">
				<p>让知识沉淀，成为前行的力量。</p>
			</div>
		</section>

		<div class="wrapper">
			<div v-for="(book, index) in books" :key="index" class="book-card" :class="{ 'is-selected': selectedCourses.includes(book.title) }">
				<div class="book-header">
					<label class="custom-checkbox">
						<input type="checkbox" :value="book.title" v-model="selectedCourses" />
						<span class="checkmark"></span>
						<span class="book-title">{{ book.title }}</span>
					</label>
				</div>
				
				<div class="book-info">
					<p class="book-author">{{ book.author }}</p>
					<div class="book-desc" v-html="book.description"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		ReportData: { type: Object, required: false },
		selected: { type: Array, default: () => [] }
	},
	data() {
		return {
		selectedCourses: [],
		books: [
			{
                title: '终身成长',
                author: '[美] 卡罗尔·德韦克',
                description: `本书是斯坦福大学心理学教授卡罗尔·德韦克给予数十年实证研究撰写的心理学经典，彻底打破了“天赋决定成就”的固化认知。`,
			},
			{
                title: '别找替罪羊',
                author: '美国亚宾泽协会',
                description: `本书是聚焦人心认知与人际心智重塑的经典读物，创新性提出“思维盒子”与自我欺骗核心理论，深刻揭示了人们习惯性推诿责任、归因外界、产生人际矛盾的底层心里根源。`,
			}
		]
		};
	},
	watch: {
        selectedCourses: {
            deep: true,
            handler(newVal) { 
                this.$emit('update:selected', newVal); 
            }
		}
	},
	mounted() {
		this.selectedCourses = [...this.selected];
	}
};
</script>

<style scoped>
/* 1. 基础容器：锁定高度 */
.body {
	background:url("../../assets/26July/logo.png") right  top  no-repeat,
				url("../../assets/26July/bg.jpg")  no-repeat;
	background-size:100% 100%,cover;
	width: 100%;
	height: 100vh;
	display: flex;
	flex-direction: column;
	align-items: center;
	overflow: hidden; /* 禁止全局滚动 */
	color: #333;
	box-sizing: border-box;
	padding: 20px 0;
}

/* 2. 头部：精致化 */
.header-section {
  padding-top: 6vh;
  text-align: center;
  margin-bottom: 15px;
}
.main-title {
  font-size: 24px;
  color: #2d3748;
  margin: 0;
  font-weight: 800;
}
.subtitle-wrapper {
  margin-top: 8px;
  display: flex;
  gap: 10px;
  justify-content: center;
}
.subtitle-badge {
  font-size: 14px;
  background: #6db1f9;
  color: white;
  padding: 2px 10px;
  border-radius: 20px;
  opacity: 0.8;
}

/* 3. 引用卡片：减少空间占用 */
.quote-card {
  width: 88%;
  background: rgba(255, 255, 255, 0.7);
  border-left: 4px solid #519beb;
  padding: 12px 15px;
  margin-bottom: 20px;
  border-radius: 4px;
}
.p-highlight {
  font-weight: bold;
  color: #519beb;
  margin: 0 0 5px 0;
}
.p-content {
  font-size: 14px;
  color: #666;
  line-height: 1.4;
}

/* 4. 书籍列表区域：核心滚动区 */
.wrapper {
  flex: 1; /* 自动撑开剩余空间 */
  width: 90%;
  overflow-y: auto; /* 局部滚动 */
  padding: 5px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  /* 隐藏滚动条 (可选) */
  scrollbar-width: thin;
}

/* 5. 书籍卡片设计 */
.book-card {
  background: white;
  border-radius: 12px;
  padding: 10px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  transition: all 0.3s ease;
  border: 2px solid transparent;
}
.book-card.is-selected {
  border-color: #008777;
  background: #fffcfb;
  transform: translateY(-2px);
}

.book-header {
  margin-bottom: 3px;
}
.book-title {
  font-size: 18px;
  font-weight: bold;
  color: #222;
}

.book-author {
  font-size: 13px;
  color: #6db1f9;
  background: #fef0f0;
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  margin-bottom: 5px;
}
.book-desc {
  font-size: 14px;
  color: #555;
  line-height: 1.6;
  text-align: justify;
}

/* 自定义复选框样式 */
.custom-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 10px;
}
.custom-checkbox input {
  display: none;
}
.checkmark {
  width: 18px;
  height: 18px;
  border: 2px solid #ccc;
  border-radius: 50%;
  display: inline-block;
  position: relative;
}
.custom-checkbox input:checked + .checkmark {
  background: #008777;
  border-color: #008777;
}
.custom-checkbox input:checked + .checkmark::after {
  content: '✓';
  color: white;
  font-size: 12px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.footer-hint {
  font-size: 12px;
  color: #999;
  margin-top: 10px;
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-5px); }
}

/* PC 端适配 */
@media screen and (min-width: 786px) {
 .body {
        background: url("../../assets/26July/pcbg.png") no-repeat center;
        background-size: cover;
    }
    .quote-card, .wrapper {
        width: 600px;
    }
    .course-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 15px;
    }
}
</style>